import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { pastFinancialdate } from "../../../lib/Misc";
import MainBody from "../../../components/MainBody/MainBody";
import { MonthRangePicker } from "../../../components/ui/monthrangepicker";
import { useMediaQuery } from "../../../components/use-media-query";
import MainTabList from "../../../components/MainBody/MainTabList";
import ContactHubDashboard from "./ContactHubDashboard";
import Incidents from "../Incidents/Incidents";
import CommonFilters from "../../../components/CommonFilters";
import { useUser } from "../../../lib/context/UserContext";
import EscalationTabs from "../Escalations/EscalationTabs";

const tabsKey = [
  {
    name: "Contact Hub Dashboard",
    tabName: "contact-hub-dashboard",
    value: 1,
  },
  {
    name: "Escaltions",
    tabName: "escalations",
    value: 2,
  },
  {
    name: "Reports & Incidents",
    tabName: "incidents",
    value: 3,
  },
];

const Dashboard = () => {
  const location = useLocation();
  const isDesktop = useMediaQuery("(min-width: 768px)");

  const query = new URLSearchParams(location.search);
  const { permission } = useUser();

  const fromMonth = query.get("from")
    ? new Date(
        `${query.get("from")?.split("-")[1]}-${
          query.get("from")?.split("-")[0]
        }-01`,
      )
    : "";
  const toMonth = query.get("to")
    ? new Date(
        `${query.get("to")?.split("-")[1]}-${query.get("to")?.split("-")[0]}-01`,
      )
    : "";

  const [selectedMonthRange, setSelectedMonthRange] = React.useState(
    fromMonth && toMonth
      ? {
          start: fromMonth,
          end: toMonth,
        }
      : {
          start: pastFinancialdate[0],
          end: pastFinancialdate[1],
        },
  );

  const selectedTab = query.get("childTab")
    ? query.get("childTab")
    : "contact-hub-dashboard";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(
    defaultActiveKey ? defaultActiveKey : 1,
  );
  const [amlDashboardValue, setAmlDashboardValue] = useState("all");

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        mainClassName="w-[calc(100%-3rem)]"
        actionContentDirect={true}
        actionClassName={"!mb-0"}
        actionContent={
          <div className="flex items-center gap-2 absolute top-4 right-4">
            <MonthRangePicker
              onMonthRangeSelect={setSelectedMonthRange}
              selectedMonthRange={selectedMonthRange}
              variant="outline"
              align={isDesktop ? "end" : "start"}
              maxDate={new Date()}
            />
            <CommonFilters
              amlDashboardFilter={true}
              setAmlDashboardValue={setAmlDashboardValue}
              amlDashboardValue={amlDashboardValue}
            />
          </div>
        }
        innerBody={true}
        parentHeight={true}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative sm:max-h-[630px] overflow-auto`}
        >
          {activeTab === 1 ? (
            <ContactHubDashboard
              selectedMonthRange={selectedMonthRange}
              amlDashboardValue={amlDashboardValue}
            />
          ) : activeTab === 2 ? (
            <EscalationTabs
              dashboard={true}
              selectedMonthRangeDashboard={selectedMonthRange}
              initalAmlDashboardValue={amlDashboardValue}
              readAccess={permission?.["escalations"]?.read}
              writeAccess={permission?.["escalations"]?.write}
            />
          ) : activeTab === 3 ? (
            <Incidents
              selectedMonthRangeDashboard={selectedMonthRange}
              readAccess={permission?.["incidents"]?.read}
              writeAccess={permission?.["incidents"]?.write}
              dashboard={true}
            />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default Dashboard;
